<template>
    <div class="commercial-disclosure-component">
        <div class="commercial-disclosure-component-title"> 特定商取引法に基づく表記</div>

        <div class="legal-name-container">
            販売業社の名称 : ELEVATE
        </div>
            
        <div class="address-container">
            所在地 : 所在地については「お問い合わせ先メールアドレス」にてご請求をいただければ、遅滞なく開示いたします。
        </div>

        <div class="phone-number-container">
            電話番号 : 電話番号については「お問い合わせ先メールアドレス」にてご請求をいただければ、遅滞なく開示いたします。
        </div>

        <div class="email-address-container">
            メールアドレス : elevatesocialwellness@gmail.com
        </div>

        <div class="head-of-operations">
            運営統括責任者 : 藤川 治己
        </div>

        <div class="additional-fees">
            追加手数料等の追加料金 : 0円
        </div>

        <div class="exchanges-and-returns">
            交換および返品（返金ポリシー）: 商品購入後の返品・交換・キャンセルには、基本的に対応しておりません。商品に欠陥がある場合のみ交換が可能ですのでご連絡ください。
        </div>

        <div class="delivery-times">
            引渡時期：講座・セミナー・コーチングセッションなど、講座提供を引き渡しとする。
        </div>

        <div class="accepted-payment-methods">
            受け付け可能な決済手段 : クレジットカード、銀行振込。
        </div>

        <div class="payment-period">
            決済期間 : クレジットカード：決済の場合はただちに処理されます。銀行振込の場合はご入金確認後。
        </div>

        <div class="price">
            販売価格 : 各商品ページに記載の金額。
        </div>
    </div>
</template>

<style scoped>
.commercial-disclosure-component {
    margin: 12px;
    margin-bottom: 50px;
    margin-top: -50px;
}

.commercial-disclosure-component-title {
    font-family: SFPRoBold;
    font-size: 16pt;
    padding-bottom: 6px;
    color: white;
}

.legal-name-container, .address-container, .phone-number-container, .email-address-container,  .head-of-operations, .additional-fees, .exchanges-and-returns, .delivery-times, .accepted-payment-methods, .payment-period, .price {
    font-family: SFPRoRegular;
    font-size: 10pt;
    color: white;
}
</style>

<script setup>
    // import { useRouter } from "vue-router";
    // const router = useRouter();
</script>

<script>
export default {
    mounted () {
        window.scrollTo(0, 0);
    }
}
</script>